import { Modal } from "../ui/components";

export class DislikeModal extends Modal {
    init() {
        super.init();

        this.dislikeSubmitBtn?.on("click", (e) => {
            e.preventDefault();
            const comment = this.dislikeInput?.element.value.trim();

            if (this.onSubmit) {
                const success = this.onSubmit(comment);
                if (success) {
                    this.hide();
                    this.clearInput();
                }
            }
        });
    }


    setOnSubmit(callback) {
        this.onSubmit = callback;
    }

    clearInput() {
        if (this.dislikeInput) {
            this.dislikeInput.element.value = "";
        }
    }

    show() {
        super.show();
        this.clearInput();
    }
}